import { FC, useCallback } from 'react';
import { MaskedOptions } from 'imask';

import { BaseFieldProps } from '../Fields.types';
import { FieldWrapper } from '../FieldWrapper';

import { FieldPatternContext } from './FieldPattern.context';
import { FieldPatternMasked } from './FieldPatternMasked';

interface FieldPatternProps extends BaseFieldProps<string> {
  options: MaskedOptions;
}

export const FieldPattern: FC<FieldPatternProps> = ({
  disabled,
  enterKeyHint,
  error,
  label,
  onBlur,
  onChange,
  onCompositionUpdate,
  onFocus,
  onKeyDown,
  onKeyUp,
  placeholder,
  value,
  options: { mask },
}) => {
  const invalid = !!error;

  const handleOnAccept = useCallback(
    (value: string) => {
      onChange({
        value,
        event: null,
      });
    },
    [onChange]
  );

  return (
    <FieldPatternContext.Provider
      value={{
        disabled,
        enterKeyHint,
        error,
        onBlur,
        onCompositionUpdate,
        onFocus,
        onKeyDown,
        onKeyUp,
        placeholder,
        value,
        invalid,
      }}
    >
      <FieldWrapper label={label} invalid={invalid}>
        <FieldPatternMasked mask={mask} onAccept={handleOnAccept} />
      </FieldWrapper>
    </FieldPatternContext.Provider>
  );
};
